import {
  Sparkles,
  useAnimations,
  useGLTF,
  useTexture,
} from "@react-three/drei";
import { useRef, useEffect } from "react";
import UseGame from "./stores/UseGame";
import * as THREE from "three";

const loopAnimations = [
  "VIKING_BOAT_AN.001",
  "CHILD_JUMPING_AN.002",
  "GUITAR_AN.001",
];
const infoAnimations = [
  "STICK_POINTING_AN.001",
  "PRESENTATOR_AN.001",
  "CROWD_WALK_DELAYED_AN.002",
  "CROWD_WALK_DELAYED_AN.001",
  "CROWD_WALK_AN.003",
  "CROWD_WALK_AN.002",
];

export default function Island(props) {
  const { nodes, animations } = useGLTF("/model/M_ISLAND.glb");


  useEffect(() => {

  }, [])
  const clicked = UseGame((state) => state.clicked);

  const group = useRef();
  const startDelayInfo = 2000;
  const startDelayReader = 1500;

  //#region TEXTURES
  const tavernTexture = useTexture("/model/TAVERN_BAKED.jpg");
  const islandTextureA = useTexture("/model/ISLAND_BAKED_1.jpg");
  const islandTextureB = useTexture("/model/ISLAND_BAKED_2.jpg");
  const islandTextureC = useTexture("/model/ISLAND_BAKED_3.jpg");
  const guysTexture = useTexture("/model/GUYS_BAKED.jpg");
  const fixTexture = useTexture("/model/FIX_BAKED.jpg");

  tavernTexture.flipY = false;
  islandTextureA.flipY = false;
  islandTextureB.flipY = false;
  islandTextureC.flipY = false;
  guysTexture.flipY = false;
  fixTexture.flipY = false;
  //#endregion TEXTURES

  const { actions } = useAnimations(animations, group);

  // Function to play the specific animation
  const playAnimationOnce = (name) => {
    const action = actions[name];
    // Check if the action exists
    if (action) {
      action.reset(); // Reset the animation to the beginning
      action.clampWhenFinished = true; // Ensure animation stays on last frame
      action.setLoop(THREE.LoopOnce); // Set loop mode to LoopOnce
      // action.setEffectiveTimeScale(0.75);
      action.play(); // Play the animation
    } else {
      console.error("Animation not found!");
    }
  };
  const resetAnimation = (name) => {
    const action = actions[name];
    // Check if the action exists
    if (action) {
      action.clampWhenFinished = false;
      action.reset(); // Reset the animation to the beginning
    } else {
      console.error("Animation not found!");
    }
  };

  useEffect(() => {
    loopAnimations.forEach((name) => {
      const action = actions[name];
      action.play();
    });
  }, [actions]);

  useEffect(() => {
    if (clicked === "reader") {
      setTimeout(() => {
        playAnimationOnce("READING_UP_AN.001");
      }, startDelayReader);
    } else {
      resetAnimation("READING_UP_AN.001");
    }

    if (clicked === "stage") {
      setTimeout(() => {
        infoAnimations.forEach((name) => {
          playAnimationOnce(name);
        });
      }, startDelayInfo);
    } else {
      infoAnimations.forEach((name) => {
        resetAnimation(name);
      });
    }
  }, [clicked]);

  return (
    <group ref={group} {...props}>
      <color args={["#040f16"]} attach="background" />
      {/* STATIC */}
      <mesh
        geometry={nodes.M_ISLAND.geometry}
        position={nodes.M_ISLAND.position}
        rotation={nodes.M_ISLAND.rotation}
        scale={nodes.M_ISLAND.scale}
      >
        <meshBasicMaterial map={islandTextureA} />
      </mesh>
      <mesh
        geometry={nodes.M_STONE_PATH.geometry}
        position={nodes.M_STONE_PATH.position}
        rotation={nodes.M_STONE_PATH.rotation}
        scale={nodes.M_STONE_PATH.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_STATIC_GUYS_PARTS.geometry}
        position={nodes.M_STATIC_GUYS_PARTS.position}
        rotation={nodes.M_STATIC_GUYS_PARTS.rotation}
        scale={nodes.M_STATIC_GUYS_PARTS.scale}
      >
        <meshBasicMaterial map={guysTexture} />
      </mesh>

      {/* PARTICLE SYSTEM */}
      <mesh
        geometry={nodes.M_TREE_BIG.geometry}
        position={nodes.M_TREE_BIG.position}
        rotation={nodes.M_TREE_BIG.rotation}
        scale={nodes.M_TREE_BIG.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_TREE_BIG001.geometry}
        position={nodes.M_TREE_BIG001.position}
        rotation={nodes.M_TREE_BIG001.rotation}
        scale={nodes.M_TREE_BIG001.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_TREE_BIG002.geometry}
        position={nodes.M_TREE_BIG002.position}
        rotation={nodes.M_TREE_BIG002.rotation}
        scale={nodes.M_TREE_BIG002.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_TREE_BIG003.geometry}
        position={nodes.M_TREE_BIG003.position}
        rotation={nodes.M_TREE_BIG003.rotation}
        scale={nodes.M_TREE_BIG002.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>

      <mesh
        geometry={nodes.M_TREE_SMALL.geometry}
        position={nodes.M_TREE_SMALL.position}
        rotation={nodes.M_TREE_SMALL.rotation}
        scale={nodes.M_TREE_BIG.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_TREE_SMALL001.geometry}
        position={nodes.M_TREE_SMALL001.position}
        rotation={nodes.M_TREE_SMALL001.rotation}
        scale={nodes.M_TREE_BIG001.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_TREE_SMALL002.geometry}
        position={nodes.M_TREE_SMALL002.position}
        rotation={nodes.M_TREE_SMALL002.rotation}
        scale={nodes.M_TREE_BIG002.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_TREE_SMALL003.geometry}
        position={nodes.M_TREE_SMALL003.position}
        rotation={nodes.M_TREE_SMALL003.rotation}
        scale={nodes.M_TREE_BIG002.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>

      <Sparkles
        size={8}
        scale={[26, 3, 26]}
        position={[0, 1.5, 0]}
        speed={0.75}
        color={"#ffe6a7"}
        count={60}
      />
      {/* CLICKABLES */}
      <mesh
        geometry={nodes.M_TAVERN.geometry}
        position={nodes.M_TAVERN.position}
        rotation={nodes.M_TAVERN.rotation}
        scale={nodes.M_TAVERN.scale}
      >
        <meshBasicMaterial map={tavernTexture} />
      </mesh>
      <mesh
        geometry={nodes.M_BEER.geometry}
        position={nodes.M_BEER.position}
        rotation={nodes.M_BEER.rotation}
        scale={nodes.M_BEER.scale}
      >
        <meshBasicMaterial map={fixTexture} />
      </mesh>
      <mesh
        geometry={nodes.M_STATUE.geometry}
        position={nodes.M_STATUE.position}
        rotation={nodes.M_STATUE.rotation}
        scale={nodes.M_STATUE.scale}
      >
        <meshBasicMaterial map={fixTexture} />
      </mesh>
      <mesh
        geometry={nodes.M_STATUE_PERSON.geometry}
        position={nodes.M_STATUE_PERSON.position}
        rotation={nodes.M_STATUE_PERSON.rotation}
        scale={nodes.M_STATUE_PERSON.scale}
      >
        <meshBasicMaterial map={fixTexture} />
      </mesh>
      <mesh
        geometry={nodes.M_STAGE.geometry}
        position={nodes.M_STAGE.position}
        rotation={nodes.M_STAGE.rotation}
        scale={nodes.M_STAGE.scale}
      >
        <meshBasicMaterial map={islandTextureB} />
      </mesh>
      <mesh
        geometry={nodes.M_WELL.geometry}
        position={nodes.M_WELL.position}
        rotation={nodes.M_WELL.rotation}
        scale={nodes.M_WELL.scale}
      >
        <meshBasicMaterial map={islandTextureA} />
      </mesh>
      <mesh
        geometry={nodes.M_ROUTE_POLE.geometry}
        position={nodes.M_ROUTE_POLE.position}
        rotation={nodes.M_ROUTE_POLE.rotation}
        scale={nodes.M_ROUTE_POLE.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_LINK_PROJECT.geometry}
        position={nodes.M_LINK_PROJECT.position}
        rotation={nodes.M_LINK_PROJECT.rotation}
        scale={nodes.M_LINK_PROJECT.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_LINK_INFORMATION.geometry}
        position={nodes.M_LINK_INFORMATION.position}
        rotation={nodes.M_LINK_INFORMATION.rotation}
        scale={nodes.M_LINK_INFORMATION.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_LINK_ABOUT_ME.geometry}
        position={nodes.M_LINK_ABOUT_ME.position}
        rotation={nodes.M_LINK_ABOUT_ME.rotation}
        scale={nodes.M_LINK_ABOUT_ME.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_FLAG_BELGIUM.geometry}
        position={nodes.M_FLAG_BELGIUM.position}
        rotation={nodes.M_FLAG_BELGIUM.rotation}
        scale={nodes.M_FLAG_BELGIUM.scale}
      >
        <meshBasicMaterial map={islandTextureC} />
      </mesh>
      <mesh
        geometry={nodes.M_CROWS.geometry}
        position={nodes.M_CROWS.position}
        rotation={nodes.M_CROWS.rotation}
        scale={nodes.M_CROWS.scale}
      >
        <meshBasicMaterial map={islandTextureA} />
      </mesh>
      <mesh
        geometry={nodes.M_BENCH.geometry}
        position={nodes.M_BENCH.position}
        rotation={nodes.M_BENCH.rotation}
        scale={nodes.M_BENCH.scale}
      >
        <meshBasicMaterial map={fixTexture} />
      </mesh>

      {/* ANIMATIONS */}
      <mesh
        name="M_VIKING_BOAT"
        geometry={nodes.M_VIKING_BOAT.geometry}
        position={nodes.M_VIKING_BOAT.position}
        rotation={nodes.M_VIKING_BOAT.rotation}
        scale={nodes.M_VIKING_BOAT.scale}
      >
        <meshBasicMaterial map={islandTextureB} />
      </mesh>
      <mesh
        name="M_GUY_READING_HEAD"
        geometry={nodes.M_GUY_READING_HEAD.geometry}
        position={nodes.M_GUY_READING_HEAD.position}
        rotation={nodes.M_GUY_READING_HEAD.rotation}
        scale={nodes.M_GUY_READING_HEAD.scale}
      >
        <meshBasicMaterial map={guysTexture} />
      </mesh>
      <mesh
        name="M_GUY_PRESENTING_HEAD"
        geometry={nodes.M_GUY_PRESENTING_HEAD.geometry}
        position={nodes.M_GUY_PRESENTING_HEAD.position}
        rotation={nodes.M_GUY_PRESENTING_HEAD.rotation}
        scale={nodes.M_GUY_PRESENTING_HEAD.scale}
      >
        <meshBasicMaterial map={guysTexture} />
      </mesh>
      <mesh
        name="M_GUY_PRESENTING_STICK"
        geometry={nodes.M_GUY_PRESENTING_STICK.geometry}
        position={nodes.M_GUY_PRESENTING_STICK.position}
        rotation={nodes.M_GUY_PRESENTING_STICK.rotation}
        scale={nodes.M_GUY_PRESENTING_STICK.scale}
      >
        <meshBasicMaterial map={fixTexture} />
      </mesh>
      <mesh
        name="M_GUITAR_UPPER"
        geometry={nodes.M_GUITAR_UPPER.geometry}
        position={nodes.M_GUITAR_UPPER.position}
        rotation={nodes.M_GUITAR_UPPER.rotation}
        scale={nodes.M_GUITAR_UPPER.scale}
      >
        <meshBasicMaterial map={guysTexture} />
      </mesh>
      <mesh
        name="M_CROWD_SLOW"
        geometry={nodes.M_CROWD_SLOW.geometry}
        position={nodes.M_CROWD_SLOW.position}
        rotation={nodes.M_CROWD_SLOW.rotation}
        scale={nodes.M_CROWD_SLOW.scale}
      >
        <meshBasicMaterial map={guysTexture} />
      </mesh>
      <mesh
        name="M_CROWD_SLOW_2"
        geometry={nodes.M_CROWD_SLOW_2.geometry}
        position={nodes.M_CROWD_SLOW_2.position}
        rotation={nodes.M_CROWD_SLOW_2.rotation}
        scale={nodes.M_CROWD_SLOW_2.scale}
      >
        <meshBasicMaterial map={guysTexture} />
      </mesh>
      <mesh
        name="M_CROWD_FAST"
        geometry={nodes.M_CROWD_FAST.geometry}
        position={nodes.M_CROWD_FAST.position}
        rotation={nodes.M_CROWD_FAST.rotation}
        scale={nodes.M_CROWD_FAST.scale}
      >
        <meshBasicMaterial map={guysTexture} />
      </mesh>
      <mesh
        name="M_CROWD_FAST_2"
        geometry={nodes.M_CROWD_FAST_2.geometry}
        position={nodes.M_CROWD_FAST_2.position}
        rotation={nodes.M_CROWD_FAST_2.rotation}
        scale={nodes.M_CROWD_FAST_2.scale}
      >
        <meshBasicMaterial map={guysTexture} />
      </mesh>
      <mesh
        name="M_CHILD_JUMPING"
        geometry={nodes.M_CHILD_JUMPING.geometry}
        position={nodes.M_CHILD_JUMPING.position}
        rotation={nodes.M_CHILD_JUMPING.rotation}
        scale={nodes.M_CHILD_JUMPING.scale}
      >
        <meshBasicMaterial map={guysTexture} />
      </mesh>

      {/* EMISSION */}
      <mesh
        geometry={nodes.M_LUMINOUS_WINDOWS.geometry}
        position={nodes.M_LUMINOUS_WINDOWS.position}
        rotation={nodes.M_LUMINOUS_WINDOWS.rotation}
        scale={nodes.M_LUMINOUS_WINDOWS.scale}
      >
        <meshBasicMaterial color="#ffffe5" />
      </mesh>

      <mesh
        geometry={nodes.M_LUMINOUS_BALLS.geometry}
        position={nodes.M_LUMINOUS_BALLS.position}
        rotation={nodes.M_LUMINOUS_BALLS.rotation}
        scale={nodes.M_LUMINOUS_BALLS.scale}
      >
        <meshBasicMaterial color="#ffffe5" />
      </mesh>
    </group>
  );
}
